<template>
  <div class="container">
    <div class="full-screen">
      <lottie-player src="/animations/new-brand-cashflow-loader.json"
                     :autoplay="true" :loop="true"
                     preserveAspectRatio="xMinYMid slice" />
    </div>
    <div class="full-screen flex-column flex-1 justify-content-center padding-right-xl ri-large-headline">
      <div class="ri-alte">רק עוד רגע</div>
      <div class="ri-alte">תכף ממשיכים</div>
    </div>
  </div>
</template>

<script>
import DDLogs from '@/DDLogs';
import { mapActions, mapState } from 'vuex';
import Segment from '@/Segment';

const ONBOARDING_STATE_REFRESH_INTERVAL = 3;
const MAX_NUMBER_OF_POLLING = 50;
export default {
  name: 'PreparingOTS',
  async created() {
    Segment.trackUserGot('PreparingOTSEntered');
    await this.fetchCredentials();
    this.startPolling();
  },
  data() {
    return {
      pollingInterval: null,
      pollingCounter: 0,
    };
  },
  beforeDestroy() {
    clearInterval(this.pollingInterval);
  },
  computed: {
    ...mapState('session', ['activeMemberFirstName', 'activeMemberLastName', 'activeMemberPhoneNumber', 'activeMemberEmail', 'segmentEventPrefix']),
    ...mapState('credentials', ['credentialsList']),
    ...mapState('ots', ['otsResults', 'jobId', 'jobStatus', 'flowConfigId', 'promptIdFromLatestPromptJob']),
  },
  methods: {
    ...mapActions('onboardingState', ['fetchOnboardingStateIfFinishedLoading', 'fetchOnboardingState']),
    ...mapActions('ots', ['isFinishedLoadingCashflow', 'getOTSResult', 'getLatestPromptJob', 'activateLLMJob']),
    ...mapActions('credentials', ['fetchCredentials']),
    startPolling() {
      this.pollingInterval = setInterval(async () => {
        const isFinishedLoadingCashflow = await this.isFinishedLoadingCashflow();
        if (isFinishedLoadingCashflow) {
          this.$emit('finishedLoadingCashflow');
        }
        this.pollingCounter += 1;
        if (this.pollingCounter === MAX_NUMBER_OF_POLLING) {
          DDLogs.log('Stuck in PreparingOts');
        }
      }, ONBOARDING_STATE_REFRESH_INTERVAL * 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.container {
  height: 100%;
  width: 100%;
  color: $riseup_dark_green;
  background-color: $riseup_beige;

  .full-screen {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    font-weight: 900;
  }

  img {
    height: 24px;
    align-self: flex-start;
  }
}

</style>
